/*
 * [2026-10-13 HAYAKUMO 追加] 予約注文の表示を、色などのバリアント切替に追従させる
 *
 * Dawn 標準の動き: 切替時に product-info.js が ProductSubmitButton の文言を「カートに追加する」へ
 * 上書きし（product-form.js toggleSubmitButton）、予約の注意書きは更新しない。
 * そこで variantChange（data.html = 選んだバリアントで描画し直したセクション）を受けて、
 *   1. 予約欄 UdgPreorder-<section_id>（注意書き＋注文へ付ける予約の印 properties[予約]）の中身
 *   2. カートボタンの文言と primary/secondary の見た目
 *   3. 「今すぐ購入」を隠すための印（product-form の udg-preorder-active クラス）
 * を描画し直した側から写す。判定はすべてサーバー側（Liquid）の結果をそのまま使う。
 * 方式は assets/restock-notify.js と同じ。
 */
(function () {
  if (window.udgPreorderLoaded) return;
  window.udgPreorderLoaded = true;

  function copyPreorderBox(sectionId, html) {
    var id = 'UdgPreorder-' + sectionId;
    var destination = document.getElementById(id);
    if (!destination) return;
    var source = html.getElementById(id);
    var on = !!source && source.getAttribute('data-preorder') === 'true';
    destination.innerHTML = source ? source.innerHTML : '';
    destination.setAttribute('data-preorder', on ? 'true' : 'false');
    var form = destination.closest('product-form');
    if (form) form.classList.toggle('udg-preorder-active', on);
  }

  function copySubmitButton(sectionId, html) {
    var id = 'ProductSubmitButton-' + sectionId;
    var destination = document.getElementById(id);
    var source = html.getElementById(id);
    if (!destination || !source) return;
    var destinationText = destination.querySelector('span');
    var sourceText = source.querySelector('span');
    if (destinationText && sourceText) destinationText.textContent = sourceText.textContent.trim();
    ['button--primary', 'button--secondary'].forEach(function (name) {
      destination.classList.toggle(name, source.classList.contains(name));
    });
  }

  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.html || !data.sectionId) return;
    copyPreorderBox(data.sectionId, data.html);
    copySubmitButton(data.sectionId, data.html);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }
})();
